import TextBox, { ITextBoxOptions } from "devextreme-react/text-box";
import React, { useEffect, useRef, useState } from "react";

interface TextBoxWithDelayProps extends React.PropsWithChildren<ITextBoxOptions> {
	textChangeDelay: number,
	onTextChanged: (value?: string) => void
}

export default function TextBoxWithDelay(props: TextBoxWithDelayProps) {

	const [value, setValue] = useState(props.value);

	const timer = useRef();

	useEffect(() => {
		if (value !== props.value) {
			clearTimeout(timer.current);
			timer.current = setTimeout(() => {
				props.onTextChanged(value);
			}, props.textChangeDelay) as any;
		}
	}, [value]);

	return (
		<TextBox {...props}
			value={value}
			valueChangeEvent="input"
			onValueChanged={(e) => setValue(e.value)}
		>
			{props.children}
		</TextBox>
	)
}